/* eslint-disable eqeqeq */
import { getScaleRequirementsForEdit } from "../services/baremos";
import * as XLSX from 'xlsx';

import Dashboard from "../Layout/Dashboard";
import { useParams } from "react-router-dom";
import {
  useClient,
  useMedicalCenters,
  useScaleRequirementsForEdit,
} from "../hooks/queries";
import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editScaleRequirements } from "../services/baremos";
import { UserRole } from "../constants";
import { Dropdown } from "primereact/dropdown";
import TabMenu from "../components/TabMenu";
import ScaleHistoryDialog from "./ScaleHistoryDialog";
import { InputTextarea } from "primereact/inputtextarea";
import  MedicalCenterSelectorModal from "./MedicalCenterSelectorModal";
import ScaleImportModal from './ScaleImportModal';
import ImportHistoryModal from "./ImportHistoryModal";

export default function ClientScaleView() {
  const { clientId } = useParams();
  const client = useClient(Number(clientId));
  const role = localStorage.getItem("role");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [requirementState, setRequirementState] = useState({});
  const [updatedRequirements, setUpdatedRequirements] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  const [showSelectorModal, setShowSelectorModal] = useState(false); 
  const [isExporting, setIsExporting] = useState(false);

  const [showImportModal, setShowImportModal] = useState(false);
  const [showImportHistory, setShowImportHistory] = useState(false);
  const queryClient = useQueryClient();
  // Función para manejar éxito en importación
  const handleImportSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: ["scaleRequirements", Number(clientId), { edit: true }],
    });
  };

  // Verifica si el cliente permite la edición de baremos
  const canEditScale = client.data?.can_edit_scale === true;
  
  const isAdminOrMaster =
    ![
      
      UserRole.SUB_ADMINISTRATOR,
      UserRole.LABORATORY,
    ].includes(role) || isAdmin;

    const canImportScale = canEditScale && isAdminOrMaster;

  const medicalCenters = useMedicalCenters({
    clientID: Number(clientId),
    enabled: isAdminOrMaster,
  });
  const hasOnlyOneMedicalCenter = medicalCenters.data?.length === 1;
  const [medicalCenter, setMedicalCenter] = useState(null);

  useEffect(() => {
    if (medicalCenters.data && medicalCenters.data.length === 1) {
      setMedicalCenter(medicalCenters.data[0].id);
    }
  }, [medicalCenters.data]);

  const requirements = useScaleRequirementsForEdit({
    clientId: Number(clientId),
    medicalCenter: medicalCenter,
    options: {
      select: (data) => {
        // Group by requirement type
        const newData = data.reduce((acc, item) => {
          const key = item.type_requirement_name;
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});
        return newData;
      },
      enabled: isAdminOrMaster ? medicalCenter !== null : true,
    },
  });

  
  const handleExportMultiple = async (selectedCenters) => {
    setIsExporting(true); // Asegúrate de tener este estado en el modal
    try {
    const workbook = XLSX.utils.book_new();

    for (const center of selectedCenters) {
      const data = await getScaleRequirementsForEdit(clientId, center.id);

      const exportData = data.flatMap((item) => ({
        "CODIGO":item.scale_requirement_id,
        "TIPO_SERVICIO": item.type_requirement_name,
        "NOMBRE_DEL_BAREMO": item.scale_name || "Sin nombre",
        "CODIGO_SERVICIO": item.requirement_id,
        "SERVICIO": item.requirement_name,
        "PRECIO": item.price !== null ? item.price : "No disponible",
        "COLECTIVO": client.data?.name || "Colectivo",
        "CENTRO_MEDICO": center.name || "Centro Médico",
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      XLSX.utils.book_append_sheet(workbook, worksheet, center.name.slice(0, 31)); // Límite de nombre de hoja en Excel
    }

    XLSX.writeFile(workbook, `Baremo_${client.data?.name || "cliente"}_multiples.xlsx`);
    } catch (error) {
      console.error("Error al exportar:", error);
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    if (requirements.data) {
      // Requirement state for table
      setRequirementState(requirements.data);
    }
  }, [requirements.data]);

  const [tabType, setTabType] = useState(null);

  const [showDialog, setShowDialog] = useState(false);

  const toast = useRef(null);

  const [filters] = useState({
    requirement_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const menuItems = Object.keys(requirementState || {}).map(
    (requirementType) => ({
      label: requirementType,
    })
  );

  // Update table items
  const selectedRequirementList =
    tabType === null
      ? Object.values(requirementState).flat()
      : Object.values(requirementState[menuItems[tabType]?.label] || {});

  // Update table selection
  const checkedItems = selectedRequirementList.filter((item) => item.enabled);

  const submitEditorChanges = () => {
    if (document.querySelectorAll(".price-cell-editor").length > 0) {
      // Si tabType es null, actualiza todos los tipos
      if (tabType === null) {
        let newState = { ...requirementState };
        document.querySelectorAll(".price-cell-editor").forEach((input) => {
          Object.keys(requirementState).forEach((type) => {
            newState[type] = newState[type].map((item) => {
              if (item.requirement_id === Number(input.id)) {
                return {
                  ...item,
                  price: input.value ? parseFloat(input.value) : null,
                  enabled: input.value !== null && input.value !== "",
                };
              }
              return item;
            });
          });
        });
        setRequirementState(newState);
        handleSaveChanges(newState);
      } else {
        document.querySelectorAll(".price-cell-editor").forEach((input) => {
          const newState = {
            ...requirementState,
            [menuItems[tabType].label]: requirementState[
              menuItems[tabType].label
            ].map((item) => {
              if (item.requirement_id === Number(input.id)) {
                return {
                  ...item,
                  price: input.value ? parseFloat(input.value) : null,
                  enabled: input.value !== null && input.value !== "",
                };
              }
              return item;
            }),
          };
          setRequirementState(newState);
          handleSaveChanges(newState);
        });
      }
    } else {
      handleSaveChanges(requirementState);
    }
  };

  const handleSaveChanges = (newRequirementState) => {
    // Validate
    const allItems = Object.values(newRequirementState).flat();
    const invalidItem = allItems.find(
      (item) =>
        item.enabled && (item.price === undefined || item.price === null)
    );

    if (invalidItem) {
      if (invalidItem.price === undefined || invalidItem.price === null) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: `El requerimiento ${invalidItem.requirement_name} de tipo ${invalidItem.type_requirement_name} fue marcado como activo pero no tiene precio.`,
          life: 10000,
        });
      }
      return;
    }

    const newUpdatedRequirements = [];
    Object.keys(newRequirementState).forEach((type) => {
      newRequirementState[type].forEach((item) => {
        // Busca el original por requirement_id
        const original = requirements.data[type]?.find(
          (orig) => orig.requirement_id == item.requirement_id
        );
        if (
          original &&
          (item.enabled !== original.enabled || item.price != original.price)
        ) {
          newUpdatedRequirements.push(item);
        }
      });
    });

    // temp: debugging
    console.log("newRequirementState", newRequirementState);
    console.log("requirements.data", requirements.data);
    console.log("newUpdatedRequirements", newUpdatedRequirements);

    setUpdatedRequirements(newUpdatedRequirements);
    setShowDialog(true);
  };

  const priceEditor = (options) => {
    return (
      <InputNumber
        inputId={String(options.rowData.requirement_id)}
        inputClassName="price-cell-editor"
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
        onKeyDown={(e) => e.stopPropagation()}
        placeholder="Indicar precio"
        min={0}
        step={0.01}
        minFractionDigits={2}
      />
    );
  };

  const cellEditor = (options) => {
    if (options.field === "price") return priceEditor(options);
  };

  return (
    <Dashboard headerTitle="Detalle del baremo" backButtonUrl="/baremos">
      <MedicalCenterSelectorModal
        medicalCenters={medicalCenters.data || []}
        visible={showSelectorModal}
        onHide={() => setShowSelectorModal(false)}
        onExport={(selectedCenters) => {
          // Array of selected medical centers
          return handleExportMultiple(selectedCenters);
        }}
      />
      <ScaleImportModal
        visible={showImportModal}
        onHide={() => setShowImportModal(false)}
        clientId={clientId}
        medicalCenterId={medicalCenter} // ← Añadir
        onSuccess={handleImportSuccess}
      />
      {client.isLoading && <i className="pi pi-spin pi-spinner"></i>}
      {client.data && (
        <div className="flex justify-content-between align-items-center mb-2">
          <h1 className="text-xl" style={{ marginBottom: "1.5rem" }}>Baremo con {client.data.name}</h1>
          <div className="flex justify-content-end" style={{ gap: "0.5rem" }}>
           
            {/* Botón de importación */}
            {canImportScale && (
              <Button
                label="Importar Baremo"
                icon="pi pi-upload"
                onClick={() => {
                  if (!medicalCenter) {
                    toast.current.show({
                      severity: 'warn',
                      summary: 'Proveedor no seleccionado',
                      detail: 'Debe seleccionar un proveedor antes de importar un baremo.',
                      life: 6000,
                    });
                    return;
                  }
                  setShowImportModal(true);
                }}
                severity="help"
              />
            )}
            {/* Botón de historial */}
            {canImportScale && (
              <Button
                label="Ver historial"
                icon="pi pi-clock"
                onClick={() => setShowImportHistory(true)}
                size="small"
              />
            )}
            {/* Modal */}
            <ImportHistoryModal
              visible={showImportHistory}
              onHide={() => setShowImportHistory(false)}
              clientId={clientId}
              medicalCenterId={medicalCenter}
            />
            <Button
              label={isExporting ? "Exportando..." : "Exportar Baremo"}
              icon="pi pi-building"
              severity="secondary"
              onClick={() => {
                if (hasOnlyOneMedicalCenter) {
                  handleExportMultiple([medicalCenters.data[0]]);
                } else {
                  setShowSelectorModal(true);
                }
              }}
              loading={isExporting}
            />
            {isAdmin && (
              <Button
                label="Ver historial"
                icon="pi pi-clock"
                onClick={() => setShowHistory(true)}
              />
            )}
            </div>
        </div>
      )}
      {isAdmin && (
        <ScaleHistoryDialog
          clientId={clientId}
          medicalCenterId={medicalCenter}
          visible={showHistory}
          onHide={() => {
            if (showHistory) setShowHistory(false);
          }}
        />
      )}
      {isAdminOrMaster && !hasOnlyOneMedicalCenter && (
        <div className="p-field mb-2 flex flex-column">
          <label htmlFor="medicalCenter">Proveedor</label>
          <Dropdown
            inputId="medicalCenter"
            name="medicalCenter"
            disabled={medicalCenters.isLoading}
            value={medicalCenter}
            onChange={(e) => setMedicalCenter(e.value)}
            options={medicalCenters.data ?? []}
            optionValue="id"
            optionLabel="name"
            loading={medicalCenters.isLoading}
            placeholder="Seleccionar proveedor"
            filterPlaceholder="Buscar proveedor"
            emptyMessage="No se hallaron proveedores para su búsqueda"
            filter
            showClear
          />
        </div>
      )}
      <Toast ref={toast} position="top-center" />
      <TabMenu
        model={menuItems}
        activeIndex={tabType}
        onTabChange={(index) => {
          if (tabType === index) setTabType(null);
          else setTabType(index);
        }}
        id="baremo-tipos"
      />
      <DataTable
        value={selectedRequirementList}
        filters={filters}
        filterDisplay="row"
        rows={20}
        dataKey="requirement_id"
        paginator
        loading={requirements.isLoading}
        selectionMode="checkbox"
        editMode="cell"
        selection={checkedItems || []}
        onSelectionChange={(e) => {
          const selected = e.value;
          if (tabType === null) {
            // Actualiza todos los tipos
            let newState = { ...requirementState };
            Object.keys(requirementState).forEach((type) => {
              newState[type] = newState[type].map((item) => {
                if (
                  selected.some((s) => s.requirement_id === item.requirement_id)
                ) {
                  return { ...item, enabled: true };
                } else {
                  return { ...item, enabled: false };
                }
              });
            });
            setRequirementState(newState);
          } else {
            const updatedRequirements = requirementState[
              menuItems[tabType].label
            ].map((item) => {
              if (
                selected.some((s) => s.requirement_id === item.requirement_id)
              ) {
                return { ...item, enabled: true };
              } else {
                return {
                  ...item,
                  enabled: false,
                };
              }
            });
            setRequirementState((prev) => ({
              ...prev,
              [menuItems[tabType].label]: updatedRequirements,
            }));
          }
        }}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
          header="Activo"
        ></Column>
        <Column
          field="requirement_name"
          filter
          filterPlaceholder="Buscar por nombre"
          header="Requerimiento"
          showFilterMatchModes={false}
          showFilterMenu={false}
        />
        <Column
          header="Precio (REF)"
          key="price"
          field="price"
          body={(item) => (
            <InputNumber
              value={item.price || null}
              disabled={!item.can_edit}
              tooltip={
                !item.can_edit
                  ? "No puedes editar los precios de este baremo"
                  : undefined
              }
              tooltipOptions={!item.can_edit ? { position: "top" } : undefined}
              suffix=" REF"
              placeholder="Indicar precio"
              min={0}
              step={0.01}
            />
          )}
          editor={
            selectedRequirementList.some((item) => item.can_edit)
              ? (options) => cellEditor(options)
              : null
          }
          onCellEditComplete={(e) => {
            const { rowData, field, newValue } = e;
            if (tabType === null) {
              // Actualiza en todos los tipos
              let newState = { ...requirementState };
              Object.keys(requirementState).forEach((type) => {
                newState[type] = newState[type].map((item) =>
                  item.requirement_id === rowData.requirement_id
                    ? {
                        ...item,
                        [field]: newValue,
                        enabled: newValue !== null,
                      }
                    : item
                );
              });
              setRequirementState(newState);
            } else {
              setRequirementState((prev) => ({
                ...prev,
                [menuItems[tabType].label]: prev[menuItems[tabType].label].map(
                  (item) =>
                    item.requirement_id === rowData.requirement_id
                      ? {
                          ...item,
                          [field]: newValue,
                          enabled: newValue !== null,
                        }
                      : item
                ),
              }));
            }
          }}
        />
      </DataTable>
      <div className="flex justify-content-end">
        <Button
          label="Guardar cambios"
          icon="pi pi-save"
          severity="success"
          onClick={submitEditorChanges}
        />
      </div>
      <ConfirmDialog
        showDialog={showDialog}
        onHide={() => setShowDialog(false)}
        updatedRequirements={updatedRequirements}
        isAdminOrMaster={isAdmin}
        toast={toast}
        clientId={clientId}
        medicalCenter={medicalCenter}
      />
    </Dashboard>
  );
}

function ConfirmDialog({
  showDialog,
  onHide,
  updatedRequirements,
  isAdminOrMaster,
  toast,
  clientId,
  medicalCenter,
}) {
  const [observation, setObservation] = useState("");

  const queryClient = useQueryClient();
  const editMutation = useMutation({
    mutationFn: editScaleRequirements,
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toast.current.show({
          severity: type,
          summary: "Éxito",
          detail: message,
          life: 3000,
        });
        queryClient.invalidateQueries({
          queryKey: ["scaleRequirements", Number(clientId), { edit: true }],
        });
        if (isAdminOrMaster) {
          queryClient.invalidateQueries({
            queryKey: [
              "scaleRequirements",
              "history",
              { clientId, medicalCenterId: medicalCenter },
            ],
          });
        }
        setObservation("");
        onHide();
      } else {
        toast.current.show({
          severity: type,
          summary: "Error",
          detail: message,
          life: 3000,
        });
      }
    },
  });

  return (
    <Dialog
      header="Confirmar cambios"
      visible={showDialog}
      draggable={false}
      onHide={() => {
        if (!editMutation.isPending) onHide();
      }}
    >
      <div className="flex flex-column">
        <h2 className="text-lg text-center">
          ¿Está seguro de que desea guardar los cambios?
        </h2>
        <span>Requerimientos a actualizar:</span>
        <ul>
          {updatedRequirements.map((req) => (
            <li key={req.requirement_name}>
              {req.requirement_name} -{" "}
              {req.enabled ? `${req.price} REF` : "Marcado como no disponible"}
            </li>
          ))}
        </ul>
        <div className="flex flex-column p-field mt-2">
          <label htmlFor="observation">Observación (obligatorio)</label>
          <InputTextarea
            id="observation"
            placeholder="Indique una observación"
            autoResize
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
          />
        </div>
        <div className="flex justify-content-end gap-3 mt-3">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            onClick={() => {
              if (!editMutation.isPending) onHide();
            }}
            severity="secondary"
            disabled={editMutation.isPending}
          />
          <Button
            label="Guardar"
            icon="pi pi-save"
            disabled={
              updatedRequirements.length === 0 || editMutation.isPending
            }
            loading={editMutation.isPending}
            onClick={() =>
              editMutation.mutate({
                clientId: Number(clientId),
                requirements: updatedRequirements,
                medicalCenter,
                observation,
              })
            }
          />
        </div>
      </div>
    </Dialog>
  );
}
